import { FC, memo } from 'react';

import { CompanyDeviceRequestPureType, DeviceTypes } from '@shared/api/graphql/generated';

import { TEXTS } from '../../texts';
import { SelectPlayerContentViewMode } from '../../../types';

import styles from './index.module.scss';

interface ModalDescriptionProps {
  contentViewMode: SelectPlayerContentViewMode;
  showStreamsDescription: boolean;
  addressHasVideoStream: boolean;
  addressIsVideoDemo?: boolean;
  isAddressEnabled?: boolean;
  isChangeDeviceFlow: boolean;
  isBindVideoStreamFlow: boolean;
  deviceRequestsByPoint: CompanyDeviceRequestPureType[];
  isVideoMode: boolean;
}

const ModalDescription: FC<ModalDescriptionProps> = ({
  contentViewMode,
  showStreamsDescription,
  addressHasVideoStream,
  addressIsVideoDemo,
  isAddressEnabled,
  isChangeDeviceFlow,
  isBindVideoStreamFlow,
  deviceRequestsByPoint,
  isVideoMode,
}) => {
  const isVideoStream = contentViewMode === SelectPlayerContentViewMode.VIDEO_STREAM && isVideoMode;

  if (isVideoStream && !addressHasVideoStream) {
    return <div className={styles.description}>{TEXTS.MODAL_BIND_SUCCESS_NO_VIDEO_STREAM_DESC}</div>;
  }

  if (showStreamsDescription) {
    return <div className={styles.description}>{TEXTS.MODAL_BIND_SUCCESS_NO_STREAM_DESC}</div>;
  }

  if ((!isChangeDeviceFlow || addressIsVideoDemo) && deviceRequestsByPoint.length !== 0) {
    const hasAndroidBox = deviceRequestsByPoint.some((request) => request.deviceType === DeviceTypes.Androidbox);
    const hasSberBoom = deviceRequestsByPoint.some((request) => request.deviceType === DeviceTypes.BoomSpeaker);

    if (hasAndroidBox && hasSberBoom) {
      return (
        <div className={styles.description}>
          {TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_AND_BOOM_REQUESTED(isAddressEnabled)}
        </div>
      );
    }

    return (
      <div className={styles.description}>
        {hasAndroidBox
          ? TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_DEVICE_REQUESTED(isAddressEnabled, isVideoStream)
          : TEXTS.MODAL_BIND_SUCCESS_DESC_SBER_BOOM_REQUESTED(isAddressEnabled)}
      </div>
    );
  }

  let successBindDeviceDescription = TEXTS.MODAL_BIND_SUCCESS_ADDRESS_NO_ACTIVE_DESC;

  if (isAddressEnabled) {
    successBindDeviceDescription = isBindVideoStreamFlow
      ? TEXTS.MODAL_VIDEO_BIND_SUCCESS_DESC
      : TEXTS.MODAL_BIND_SUCCESS_DESC;
  }

  return <div className={styles.description}>{successBindDeviceDescription}</div>;
};

export default memo(ModalDescription);
